import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Login } from './components/auth/Login';
import { Signup } from './components/auth/Signup';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './store/store';
import { useAuth } from './contexts/AuthContext';
import { clearUser } from './store/slices/authSlice';
import { Analytics } from '@vercel/analytics/react';

// Import your other components here
import VeniceMarketplace from './components/VeniceMarketplace';
import { ProtectedRoute } from './components/ProtectedRoute';
import PaymentSuccess from './components/payment/PaymentSuccess';
import AccountSettings from './components/account/AccountSettings';

const AppContent: React.FC = () => {
  const { isAuthenticated, loading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signOut } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow container mx-auto px-4 py-8">
        <Routes>
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/" /> : <Login />
          } />
          <Route path="/signup" element={
            isAuthenticated ? <Navigate to="/" /> : <Signup />
          } />
          {/* Marketplace is accessible without login */}
          <Route path="/" element={<VeniceMarketplace />} />
          
          {/* Payment routes */}
          <Route path="/venice/payment/success" element={<PaymentSuccess />} />
          <Route path="/venice/payment/cancel" element={<Navigate to="/" />} />
          <Route path="/venice/credit/success" element={<PaymentSuccess />} />
          <Route path="/venice/credit/cancel" element={<Navigate to="/" />} />
          
          {/* Protected routes that require authentication */}
          <Route path="/account-settings" element={
            <ProtectedRoute>
              <Navigate to="/?tab=accountSettings" replace />
            </ProtectedRoute>
          } />
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Provider store={store}>
        <ThemeProvider>
          <AuthProvider>
            <Toaster position="top-right" />
            <AppContent />
            <Analytics />
          </AuthProvider>
        </ThemeProvider>
      </Provider>
    </Router>
  );
};

export default App; 